module.exports = __webpack_public_path__ + "img/futuro-outline.d32ad06c.svg";